import React, { useState, useEffect, } from 'react';
import {
  Container,
  ContainerDivs,
  Label,
  DivAddEmp,
  AddEmp,
  DadosStdt,
  SpanFrequency,
  LegendBox,
  ToGoBack,
  DivDados,
  List,
  DivBimRow,
  DivBimHeader,
  DivBimCell,
  DivSignatureArea,
  Emp,
  SignatureBlock,
  Line,
  DivBimTable,
  DivNameMatter,
  SpanNameMatter,
  Grade,
  PrintButton,
  SignMessageButtonText,
  SignMessageButtonTextBold,
  ContLogo,
  Preview,
  InfoContainer,
  UpContainer
} from './style';


import GlobalStyle from './style';

import {
  allTheBulletinsConcept,
  fetchLogo,
  clssInfo,
  GetMatter
} from '../../Api';

//import GlobalStyle from './style';

import { IoCheckmarkSharp, IoCloseSharp } from "react-icons/io5";

import { FcSurvey } from "react-icons/fc";

import { useNavigate, useParams } from 'react-router-dom';

import LoadingSpinner from '../../components/Loading';

const AllTheBulletins = () => {

  const navigate = useNavigate()
  //const [bimestre, setBimestre] = useState({});
  //const [bimonthly, setBimonthly] = useState([]);
  const [Bulletins, setBulletins] = useState([]);
  const [cla$$, setClass] = useState([]);
  const [dataCla$$, setdataClass] = useState([]);
  const [/*teacher*/, setTeacher] = useState([]);
  const [nameSchool, setNameSchool] = useState('')
  const [logoUrl, setLogoUrl] = useState('');
  const [matters, setMatter] = useState([]);
  const [loading, setLoading] = useState(true);

  const { idClass } = useParams();
  const { idBim } = useParams();

  const [assessmentRegime, setAssessmentRegime] = useState('');

  useEffect(() => {
    (async () => {
      setLoading(true);
      console.log("idClass", idClass, "idBim", idBim)
      const idSchool = JSON.parse(sessionStorage.getItem("id-school"));
      // materias da escola na ordem do usuario (EF no fim)
      try {
        const resMatter = await GetMatter(idSchool);
        const EF_NAME = 'EDUCAÇÃO FÍSICA';
        const nrm = (s = '') => s.trim().toUpperCase();
        const rawMatters = resMatter.data.data || [];
        const orderedMatters = [...rawMatters].sort((a, b) => {
          const aEF = nrm(a.name) === EF_NAME;
          const bEF = nrm(b.name) === EF_NAME;
          if (aEF) return 1;
          if (bEF) return -1;
          return 0;
        });
        setMatter(orderedMatters);
      } catch (e) {
        console.error('Erro ao buscar materias:', e);
      }
      const nameSchool = sessionStorage.getItem("School");
      setNameSchool(nameSchool)
      setAssessmentRegime(sessionStorage.getItem('assessmentRegime'))

      const resClass = await clssInfo(idClass);
      setdataClass(resClass)

      const res = await allTheBulletinsConcept({
        idClass,
        id_iStQuarter: idBim,
      });
      console.log("resposta boletins", res);
      // Aqui você pode setar os dados no estado, se quiser

      // pega o regime retornado do backend
      const regime = res.data.data.bimestre?.assessmentRegime;

      setAssessmentRegime(regime);
      setBulletins(res.data.data.boletins);
      setClass(res.data.data.turma);
      //setBimestre(res.data.data.bimestre);

      const regentTeachers = res.data.data.turma.regente;

      if (regentTeachers.length > 0) {
        setTeacher(regentTeachers[0]); // Se quiser só o primeiro
        // OU
        // setTeacher(regentTeachers); // Se quiser todos em um array
      } else {
        setTeacher(null);
      }

      const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
      //const cachedLogoId = localStorage.getItem(`school-logo-id-${idSchool}`);

      if (cachedLogo) {
        console.log('busca pelo storage local')
        setLogoUrl(cachedLogo);
        //setlogoId(cachedLogoId);
      } else {

        console.log('busca no s3')
        const logoRes = await fetchLogo(idSchool);

        console.log('busca logo', logoRes)
        if (logoRes?.url) {
          setLogoUrl(logoRes.url);
          //setlogoId(logoRes._id);
          localStorage.setItem(`school-logo-${idSchool}`, logoRes.url);
          localStorage.setItem(`school-logo-id-${idSchool}`, logoRes._id);

        }
      }

      setLoading(false);
    })();

  }, [idBim, idClass]);

  const messageButtonClick = () => {
    navigate(-1);
  };

  const handlePrint = () => {
    window.print();
  };

  const periodLabel = assessmentRegime === 'TRIMESTRAL' ? 'TRIM' : 'BIM';

  // ordena as materias conforme a ordem definida pelo usuario (campo `order`
  // vindo do GetMatter), com a Educacao Fisica sempre no final.
  const norm = (s = '') => s.trim().toUpperCase();
  const sortByUserOrder = (entries) => {
    const orderIndex = new Map((matters || []).map((m, i) => [norm(m.name), i]));
    const big = Number.MAX_SAFE_INTEGER;
    return [...entries].sort((a, b) => {
      const ia = orderIndex.has(norm(a.matterName)) ? orderIndex.get(norm(a.matterName)) : big;
      const ib = orderIndex.has(norm(b.matterName)) ? orderIndex.get(norm(b.matterName)) : big;
      return ia - ib;
    });
  };


  return (
    <Container>
      {<GlobalStyle />} {/* Adicionando estilos globais */}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <ContainerDivs>
            <div className="no-print">
              <h3>Atenção antes de imprimir</h3>
              <p>
                Caso o boletim possua muitas matérias e não caiba totalmente em uma única folha,
                diminua a <strong>escala de impressão</strong> nas configurações da impressora.
                Sugestão: <strong>90%</strong>, <strong>85%</strong> ou <strong>80%</strong>.
              </p>
            </div>
            <PrintButton className="no-print" onClick={handlePrint}>
              Imprimir
            </PrintButton>
            {Bulletins
              .slice()
              .sort((a, b) => a.nome.localeCompare(b.nome))
              .map((aluno, index) => (
                <DivAddEmp id="containerDivs" key={aluno.id || index}>
                  <ContLogo>
                    {(logoUrl) && (
                      <Preview src={logoUrl} alt="Logo da escola" />
                    )}
                    <h2>Boletim</h2>
                  </ContLogo>

                  <AddEmp>
                    {assessmentRegime === 'BIMESTRAL' && (
                      <h3>1º Bimestre</h3>
                    )}
                    {assessmentRegime === 'TRIMESTRAL' && (
                      <h3>1º Trimestre</h3>
                    )}
                  </AddEmp>

                  <DadosStdt>
                    <UpContainer>
                      <InfoContainer>
                        <span><strong>Escola:</strong> {nameSchool}</span>

                        <span>
                          <strong>Série:</strong> {dataCla$$?.data?.data?.[0]?.serie} - {dataCla$$?.data.data?.[0]?.level}
                        </span>

                        <span>
                          <strong>Turma:</strong> {dataCla$$?.data?.data?.[0]?.name}
                        </span>

                        <span>
                          <strong>Ano Letivo:</strong> {dataCla$$?.data?.data?.[0]?.year}
                        </span>

                        <span>
                          <strong>Professor(a):</strong> {cla$$.regente.map(prof => prof.nome).join(", ")}
                        </span>

                        <span><strong>Aluno(a):</strong> {aluno.nome}</span>
                      </InfoContainer>

                      <SpanFrequency>
                        <span>
                          <IoCheckmarkSharp color='#00fa00' fontSize="30px" /> Presenças: {aluno.frequencia.totalPresencas} |{" "}
                          <IoCloseSharp color='#ff050a' fontSize="30px" /> Faltas: {aluno.frequencia.totalFaltas}
                        </span>
                        <span>
                          <FcSurvey fontSize="25px" /> Faltas Justificadas: {aluno.frequencia.totalFaltasJustificadas}
                        </span>
                      </SpanFrequency>
                    </UpContainer>

                    <LegendBox>
                      <h3>Legenda</h3>
                      <p><strong style={{ color: 'var(--green)' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                      <p><strong style={{ color: '#3b82f6' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                      <p><strong style={{ color: '#e08a0b' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                      <p><strong style={{ color: 'var(--coral, #e5484d)' }}>D</strong> - Não alcançou as capacidades básicas</p>
                    </LegendBox>
                  </DadosStdt>

                  <DivDados>
                    <List>
                      {sortByUserOrder(Object.entries(aluno.totalPorMateria)
                        .map(([matterName, grade]) => ({ matterName, grade })))
                        
                        .map(grd => (
                          <Emp key={grd.matterName}>
                            <DivNameMatter>
                              <SpanNameMatter>{grd.matterName}</SpanNameMatter>
                            </DivNameMatter>

                            <Grade>
                              <DivBimTable>
                                <DivBimRow>
                                  <DivBimHeader>1º {periodLabel}</DivBimHeader>
                                  <DivBimCell grade={grd.grade}>{grd.grade}</DivBimCell>
                                </DivBimRow>

                                <DivBimRow>
                                  <DivBimHeader>2º {periodLabel}</DivBimHeader>
                                  <DivBimCell>-</DivBimCell>
                                </DivBimRow>

                                <DivBimRow>
                                  <DivBimHeader>3º Bim</DivBimHeader>
                                  <DivBimCell>-</DivBimCell>
                                </DivBimRow>

                                {assessmentRegime !== 'TRIMESTRAL' && (
                                  <DivBimRow>
                                    <DivBimHeader>4º {periodLabel}</DivBimHeader>
                                    <DivBimCell>-</DivBimCell>
                                  </DivBimRow>
                                )}
                              </DivBimTable>
                            </Grade>
                          </Emp>
                        ))}
                    </List>
                  </DivDados>

                  <DivSignatureArea>
                    <SignatureBlock>
                      <Line />
                      <Label>Assinatura do Professor</Label>
                    </SignatureBlock>

                    <SignatureBlock>
                      <Line />
                      <Label>Assinatura dos Pais ou Responsável</Label>
                    </SignatureBlock>
                  </DivSignatureArea>
                </DivAddEmp>
              ))}
          </ContainerDivs>
          <ToGoBack onClick={messageButtonClick}>
            <SignMessageButtonText>Voltar para a</SignMessageButtonText>
            <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
          </ToGoBack>
        </>
      )}
    </Container>
  )
}

export default AllTheBulletins